import { useState } from "react";
import { toast } from "sonner";
import { getUpsellAttachmentUrl } from "@/hooks/use-upsells";
import { SrIcon } from "@/components/ui/SrIcon";

/**
 * VIB-695-followup: Liten "vedlagt PDF"-pille som åpner signed URL til
 * upsell-vedlegget i en ny fane. Vises kun når upsell-raden har
 * attachment_path satt (typisk for mersalg importert via PDF).
 */
interface Props {
  path: string;
  filename: string | null;
}

export function UpsellAttachmentBadge({ path, filename }: Props) {
  const [loading, setLoading] = useState(false);

  async function handleClick(e: React.MouseEvent) {
    e.stopPropagation();
    setLoading(true);
    try {
      const url = await getUpsellAttachmentUrl(path);
      if (!url) {
        toast.error("Kunne ikke åpne vedlegg");
        return;
      }
      window.open(url, "_blank", "noopener,noreferrer");
    } finally {
      setLoading(false);
    }
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={loading}
      className="inline-flex items-center gap-1 text-[10px] px-1.5 py-0.5 rounded bg-blue-100 text-blue-800 uppercase tracking-wider hover:bg-blue-200 transition-colors"
      title={filename ?? "Vis vedlegg"}
    >
      {loading ? (
        <SrIcon name="loader2" className="w-3 h-3 animate-spin" />
      ) : (
        <SrIcon name="paperclip" className="w-3 h-3" />
      )}
      Vedlagt PDF
    </button>
  );
}
